var _style, _desc, _g, _g2, _g3, _path, _path2, _path3, _polygon, _path4, _polygon2, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleHub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 89 89",
    style: {
      enableBackground: "new 0 0 89 89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FFCC00;}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Clip-12"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.7,44.5c0,8.4-6.8,15.2-15.2,15.2c-6.4,0-12.1-4-14.3-10.1l-8.7,7c6.7,12.7,22.4,17.6,35.1,10.9 c8.5-4.5,13.9-13.4,13.9-23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.7,44.5c0,4.9-2.4,9.5-6.4,12.4l8.6,6.9c5.5-4.9,8.6-11.9,8.6-19.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.3,44.5c0-1.8,0.3-3.5,0.9-5.2l-8.7-7c-4,7.6-4,16.6,0,24.2l8.7-7C29.6,48,29.3,46.3,29.3,44.5z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "30.2,39.3 30.2,39.3 30.2,39.3 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.5,29.3c3.2,0,6.4,1,8.9,2.9l8-7.4c-10.8-9.4-27.2-8.1-36.6,2.7c-1.3,1.5-2.4,3.1-3.3,4.9l8.7,7 C32.4,33.3,38.1,29.3,44.5,29.3z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "30.2,49.6 30.2,49.6 30.2,49.6 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.5,42.5v2l-4.4,6.9H45.5V40.6h23.1C69.6,40.6,70.5,41.5,70.5,42.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleHub);
export default __webpack_public_path__ + "static/media/google-hub.e6ce0aea882c0f7335668d5ca7d6a2a5.svg";
export { ForwardRef as ReactComponent };